import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { AddressComponent } from './address/address.component';
import { AofComponent } from './aof/aof.component';
import { AddressInfoComponent } from './nominee/address-info/address-info.component';
import { BankComponent } from './bank/bank.component';
import { CompleteComponent } from './complete/complete.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { DiyRoutingModule } from './diy-routing.module';
import { FatcaComponent } from './fatca/fatca.component';
import { FileUploadComponent } from '../common/file-upload/file-upload.component';
import { ForeignAddressComponent } from './foreign-address/foreign-address.component';
import { GuardianInfoComponent } from './nominee/guardian-info/guardian-info.component';
import { PhotoComponent } from './photo/photo.component';
import { MenuComponent } from './menus/menu.component';
import { NgxMyDatePickerModule } from '@mksasi/ngx-mydatepicker';
import { NgxUploaderModule } from '@angular-ex/uploader';
import { NgxUiLoaderConfig, NgxUiLoaderModule } from 'ngx-ui-loader';
import { NomineeComponent } from './nominee/nominee.component';
import { NomineeeInfoComponent } from './nominee/nominee-info/nominee-info.component';
import { OCIPIOComponent } from './ocipio/ocipio.component';
import { PanComponent } from './pan/pan.component';
import { PassportDetailsComponent } from './passport-details/passport-details.component';
import { RIDetailsComponent } from './ri-details/ri-details.component';
import { SegmentsComponent } from './segments/segments.component';
import { ToastrModule, ToastNoAnimationModule } from 'ngx-toastr';
import { VisaComponent } from './visa/visa.component';
import {WebcamModule} from 'ngx-webcam';
import { CountDownModule } from '../common/count-down/count-down.module';
import { DigitOnlyDirective } from './digit-only.directive';
import { GstNumberDirective } from './GstNumberDirective.directive';
import { AlphanumericDirective } from './alphanumeric.directive';
import { AlphabetsOnlyDirective } from './alphapets.directive';
import { ErrorModalComponent } from '../common/error-modal/error-modal.component';
import { ImageCropperModule } from 'ngx-image-cropper';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { SignatureComponent } from './signature/signature.component';
import { TermsdecComponent } from './termsdec/termsdec.component';
const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  "bgsColor": "#292076",
  "bgsOpacity": 0.5,
  "bgsPosition": "bottom-right",
  "bgsSize": 60,
  "bgsType": "ball-spin-clockwise",
  "blur": 5,
  "delay": 0,
  "fastFadeOut": true,
  "fgsColor": "#292076",
  "fgsPosition": "center-center",
  "fgsSize": 60,
  "fgsType": "ball-spin-clockwise",
  "gap": 24,
  "logoPosition": "center-center",
  "logoSize": 120,
  "masterLoaderId": "master",
  "overlayBorderRadius": "0",
  "overlayColor": "rgba(40, 40, 40, 0.8)",
  "pbColor": "#292076",
  "pbDirection": "ltr",
  "pbThickness": 3,
  "hasProgressBar": true,
  "text": "",
  "textColor": "#FFFFFF",
  "textPosition": "center-center",
  "maxTime": -1,
  "minTime": 300
}

@NgModule({
    declarations: [
        AddressComponent,
        AddressInfoComponent,
        AofComponent,
        BankComponent,
        CompleteComponent,
        FatcaComponent,
        FileUploadComponent,
        ForeignAddressComponent,
        GuardianInfoComponent,
        PhotoComponent,
        MenuComponent,
        NomineeComponent,
        NomineeeInfoComponent,
        PanComponent,
        PassportDetailsComponent,
        RIDetailsComponent,
        SegmentsComponent,
        OCIPIOComponent,
        VisaComponent,
        DigitOnlyDirective,
        GstNumberDirective,
        AlphanumericDirective,
        AlphabetsOnlyDirective,
        ErrorModalComponent,
        SignatureComponent,
        TermsdecComponent
        
    ],
    imports: [
      AutocompleteLibModule,
      BrowserAnimationsModule,
      BrowserModule,
      CarouselModule,
      FormsModule,
      DiyRoutingModule,
      ReactiveFormsModule,
      NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
      NgxUploaderModule,
      ToastrModule.forRoot(),
      ToastNoAnimationModule.forRoot(),
      NgxMyDatePickerModule.forRoot(),
      WebcamModule,CountDownModule,PdfViewerModule,
      ImageCropperModule
    ],
    exports: [
      FileUploadComponent,
      MenuComponent,
      ErrorModalComponent
    ],
    providers: [],
    bootstrap: [MenuComponent]
})

export class DiyModule { }
